import React from 'react';
import MyApp from './Request Appointment/appointment/appointmentDate';

function CheckStatusPage() {
  return <MyApp />;
}

export default CheckStatusPage;
